import React from 'react'
import Seo from '../components/Seo';
import '../App.css'
import winnerMain from '../finalistsheadshot/winner-main.webp'
import LazyLoad from 'react-lazyload';
import Ethan from "../finalistsheadshot/gt.webp"
import Jaansi from "../finalistsheadshot/pe.webp"
import Edward from "../finalistsheadshot/cm.webp"
import Vishnu from "../finalistsheadshot/iad.webp"
import Antara from "../finalistsheadshot/uil.webp"
import Ruuhan from "../finalistsheadshot/ruhan.png"

// Medal badge component
const MedalBadge = ({ type }) => {
  const colors = {
    gold: { bg: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)', text: '#7c5800' },
    silver: { bg: 'linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)', text: '#4a4a4a' },
    bronze: { bg: 'linear-gradient(135deg, #CD7F32 0%, #B87333 100%)', text: '#5c3a1d' }
  };

  return (
    <span style={{
      display: 'inline-block',
      padding: '6px 16px',
      borderRadius: '20px',
      background: colors[type].bg,
      color: colors[type].text,
      fontSize: '0.85rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
    }}>
      {type} Medal
    </span>
  );
};

// Winner card with bio
const WinnerCardWithBio = ({ image, name, medal, location, bio, featured = false }) => (
  <div style={{
    background: '#fff',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: featured ? '0 8px 30px rgba(0, 77, 153, 0.15)' : '0 4px 20px rgba(0, 0, 0, 0.06)',
    border: featured ? '2px solid #004d99' : '1px solid #e8eef3',
    marginBottom: '24px'
  }}>
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      <div style={{ width: '200px', minHeight: '280px', backgroundColor: '#f8f9fa', flexShrink: 0 }}>
        <LazyLoad once offset={100}>
          <img
            src={image}
            alt={name}
            className="no-invert-image-partners-css"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              minHeight: '280px'
            }}
          />
        </LazyLoad>
      </div>
      <div style={{ flex: 1, padding: '28px', minWidth: '280px' }}>
        <MedalBadge type={medal} />
        <h3 style={{
          fontSize: '1.4rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginTop: '16px',
          marginBottom: '8px'
        }}>
          {name}
        </h3>
        <p style={{ fontSize: '0.95rem', color: '#004d99', fontWeight: '500', marginBottom: '16px' }}>
          {location}
        </p>
        <p style={{ fontSize: '0.95rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
          {bio}
        </p>
      </div>
    </div>
  </div>
);

function WinnersThree() {
  return (
    <div>
      <Seo
        title="Winners"
        path="/winners"
        description="The medal-winning finalists of the International Research Olympiad — gold, silver, and bronze winners from the Finals round."
      />
      {/* Hero Image */}
      <div style={{
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
        marginBottom: '50px'
      }}>
        <LazyLoad once offset={100}>
          <img
            src={winnerMain}
            alt="2024 IRO Finals"
            style={{ width: '100%', display: 'block' }}
          />
        </LazyLoad>
      </div>

      {/* Intro Section */}
      <div style={{ textAlign: 'center', marginBottom: '40px', maxWidth: '800px', margin: '0 auto 40px auto' }}>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '20px'
        }}>
          2024 IRO Winners
        </h2>
        <p style={{
          fontSize: '1.05rem',
          color: '#555',
          lineHeight: '1.8',
          marginBottom: '16px'
        }}>
          The International Finals Exam took place from <strong>May 31st to June 2nd, 2024</strong>.
        </p>
      </div>

      {/* Quote Card */}
      <div style={{
        background: '#f8f9fa',
        borderRadius: '16px',
        padding: '32px',
        marginBottom: '40px',
        borderLeft: '4px solid #004d99'
      }}>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', fontStyle: 'italic', marginBottom: '12px' }}>
          "What sets the IRO apart is our commitment to critical thinking, which is essential for scientific research. We've seen a high number of contestants who possess extraordinary potential—and who are serious and motivated about their research-based, real-world interests."
        </p>
        <p style={{ fontSize: '0.95rem', color: '#1a1a2e', fontWeight: '600', marginBottom: '24px' }}>
          — Rishab Kumar Jain, President and Chair of the Student Board of Advisors
        </p>

        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', fontStyle: 'italic', marginBottom: '12px' }}>
          "The IRO Finals took place in a time like no other, and students showed a level of adaptability and resilience that was remarkable. Each student tackled a crucial issue, and presented their solutions so that they would matter to the world today."
        </p>
        <p style={{ fontSize: '0.95rem', color: '#1a1a2e', fontWeight: '600', margin: 0 }}>
          — Yashvir Sabharwal, Executive & Education Coordinator
        </p>
      </div>

      {/* Description */}
      <div style={{ textAlign: 'center', marginBottom: '50px', maxWidth: '800px', margin: '0 auto 50px auto' }}>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', marginBottom: '20px' }}>
          The 2024 IRO Finals showcased some of the most promising young minds in the world. With its dedication to critical thinking and real-world application of knowledge, the IRO is shaping the next generation of innovative leaders who will tackle global challenges and make a lasting impact on society.
        </p>
        <a href="/press-releases" style={{ color: '#004d99', fontWeight: '600', textDecoration: 'none' }}>
          View the entire Press Release here →
        </a>
      </div>

      {/* Gold Medalist */}
      <div style={{ marginBottom: '50px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px'
          }}>
            🥇
          </div>
          <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a2e', margin: 0 }}>
            Gold Medalist
          </h3>
        </div>

        <WinnerCardWithBio
          image={Jaansi}
          name="Jaansi Patel"
          medal="gold"
          location="New Jersey • Phillips Exeter Academy"
          bio="Jaansi Patel is a 16 year old junior from New Jersey, currently studying at Phillips Exeter Academy in New Hampshire. She is passionate about applying neuropsychology research for mental health advocacy. In her free time, Jaansi enjoys running her school's annual TED event, teaching computer science to fellow Girl Scouts, and hosting LearnOn Podcast, the science show by kids, for kids, with her younger brother."
          featured={true}
        />
      </div>

      {/* Silver Medalists */}
      <div style={{ marginBottom: '50px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px'
          }}>
            🥈
          </div>
          <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a2e', margin: 0 }}>
            Silver Medalists
          </h3>
        </div>

        <WinnerCardWithBio
          image={Edward}
          name="Edward Kang"
          medal="silver"
          location="Upper Saddle River, New Jersey • Bergen County Academies"
          bio="A sophomore in high school from Upper Saddle River in Northern New Jersey. He has moved several times between the US and South Korea, experiencing American, Korean, and British education systems. He started learning machine learning for research about two years ago and has conducted research into diagnosing Autism Spectrum Disorder and ADHD using retinal images. Beyond research, he's a Baritone in school and church choirs, a chess player and teacher."
        />

        <WinnerCardWithBio
          image={Antara}
          name="Antara Chhabra"
          medal="silver"
          location="Bengaluru, India • Shri Ram Global School"
          bio="A grade 12 student from Bengaluru, India. Her interests range from reading books of various genres to engaging in scientific discussion and research. Playing basketball, singing, and writing poems, songs, and stories are what she enjoys in her spare time. She is extremely passionate about doing her bit to help make the world a better place and to leave a dent in the universe!"
        />
      </div>

      {/* Bronze Medalists */}
      <div style={{ marginBottom: '40px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #CD7F32 0%, #B87333 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px'
          }}>
            🥉
          </div>
          <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a2e', margin: 0 }}>
            Bronze Medalists
          </h3>
        </div>

        <WinnerCardWithBio
          image={Vishnu}
          name="Vishnu Mangipudi"
          medal="bronze"
          location="Seattle, Washington • Lakeside School"
          bio="A sophomore at the Lakeside School with a deep passion for learning about the world around him. He is interested in the intersection of computer programming and scientific disciplines. In his research, he has coded machine-learning models addressing environmental and medical issues, including models that diagnose heart arrhythmias and analyze regions of glacial calving from satellite data."
        />

        <WinnerCardWithBio
          image={Ruuhan}
          name="Ruuhan Anand"
          medal="bronze"
          location="Singapore • Raffles Institution"
          bio="A student at Raffles Institution (class of 2025) with a burgeoning passion for biology, chemistry, and biomedical research. While he hopes to pursue a career in medicine or research in the future, you can find him cafe-hopping, reading fiction or binging anime series in his free time."
        />

        <WinnerCardWithBio
          image={Ethan}
          name="Ethan Sullivan"
          medal="bronze"
          location="Miami, Florida • Ransom Everglades School"
          bio="A junior at Ransom Everglades School. A dedicated scholar-athlete, Ethan is the president of his school's Mu Alpha Theta chapter while also serving as captain of the varsity cross country team and earning three-time All-American honors in triathlon. His passion for neuroscience and community service led to his Eagle Scout project focused on improving stroke outcomes in underserved communities."
        />
      </div>

      {/* Press Release Link */}
      <div style={{
        textAlign: 'center',
        padding: '30px',
        backgroundColor: '#f8f9fa',
        borderRadius: '12px'
      }}>
        <p style={{ fontSize: '1rem', color: '#555', margin: 0 }}>
          View the complete <a href="/press-releases" style={{ color: '#004d99', fontWeight: '600' }}>Press Release</a> for more details about the 2024 IRO Finals.
        </p>
      </div>
    </div>
  )
}

export default WinnersThree
